module.exports = __webpack_public_path__ + "img/no-picture.57d1ca59.svg";